import { formatDurationLong } from '@neptune/shared/common-util';

import { KnownAttributes } from 'domain/experiment/attribute';

import { FloatCriterion, IntegerCriterion, PartialSearchCriterion } from '../search-query-model';
import { criterionHasAttributeAndOperator } from '../search-query-model-core-utils';

import { CriterionHelpers } from './types';

export function isTimeCriterion(
  criterion: PartialSearchCriterion,
): criterion is IntegerCriterion | FloatCriterion {
  return (
    criterionHasAttributeAndOperator(criterion) &&
    (criterion.attribute === KnownAttributes.MonitoringTime ||
      criterion.attribute === KnownAttributes.RunningTimeSeconds ||
      criterion.attribute === KnownAttributes.ExperimentRunningTimeSeconds)
  );
}

export const timeCriterionHelpers: CriterionHelpers<IntegerCriterion | FloatCriterion> = {
  getReadableValue: (criterion) => formatDurationLong(criterion.value / 60),
  getShortReadableValue: (criterion) => formatDurationLong(criterion.value / 60),
  isComplete(criterion) {
    return criterion.value != null;
  },
};
